module.exports = __webpack_public_path__ + "static/media/ff1_bildmarke_dark.e85b7dd3.svg";